import { NODE_ENV, TENANT_INFO } from 'src/config';

export const getDefaultAssessmentsQueryParams = (patientId: string, user: any): string => {
  const { organization, userName } = user?.getCurrentUser?.() ?? {};
  if (!patientId || !user) return '';
  return `&patientUUID=${patientId}&userName=${userName}&organizationUUID=${organization}&appUUID=${
    TENANT_INFO.tenantName
  }${NODE_ENV ? `-${NODE_ENV}` : ''}`;
};
